/**
 * @description 是否包含此类型的优惠券
 */
let hasCouponType = (counponList, counponType) => {
    if (!Array.isArray(counponList)) return false;
    return counponList.some((item) => {
        return item.couponType == counponType;
    });
};

/**
 * @param {string} type 查找类型
 * @description 查找当前最优的优惠券红包
 */
let findOptimalCoupon = (counponList, type = "conpon") => {
    if (!Array.isArray(counponList)) return 0;
    let result = 0;
    let minPrice = 0;
    const postageType = 4;
    counponList.forEach((item, index) => {
        let currentCouponType = parseInt(item.couponType);
        let currentPrice = parseFloat(item.couponValue);
        if (type == "conpon" && currentCouponType != postageType) {
            if (currentPrice > minPrice) {
                minPrice = currentPrice;
                result = index;
            }
        } else if (type == "postage" && currentCouponType == postageType) {
            if (currentPrice > minPrice) {
                minPrice = currentPrice;
                result = index;
            }
        }
    });
    return result;
};

/**
 * @param {string} status 状态
 * @description 设置运费券状态
 */
let setPostageCouponListStatus = (context, counponList, status = true) => {
    if (!Array.isArray(counponList)) return;
    counponList.forEach((item) => {
        context.$set(item, "disabled", status);
    });
};

/**
 *  @description 获取商品赋新的字段名
 */
let setProductListFieldName = (fieldName, productList) => {
    let temp = [];
    productList.forEach((item) => {
        temp.push({
            productId: item.productId,
            [`${fieldName}`]: item.quantity,
        });
    });
    return temp;
};

export {
    setProductListFieldName,
    hasCouponType,
    findOptimalCoupon,
    setPostageCouponListStatus,
};
